/// <amd-module name="TFS/Admin/Groups/Common/Redux/DataSource/PermissionsProjectLevelDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const DataProviderId = "ms.vss-admin-web.org-admin-permissions-project-level-data-provider";

export function getProjectLevelPermissions(pageContext: IVssPageContext): Promise<any | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");

    // Using ignoreCache = true to make sure we get the latest data from the server on refresh.
    return contributionService
        .getDataAsync<any>(DataProviderId, {}, true)
        .then(result => {
            return result;
        });
}